import { firstValueFrom } from 'rxjs';
import { LoginStatus, loginStatus$ } from '../store/loginV2';
import { api } from '../api';
import type { components } from '../api/types';
import { suggestions } from '../store/suggestions';

export type Suggestion = components['schemas']['Suggestion'];
const getSuggestion = api.path('/api/suggestion').method('get').create();

export async function getSuggestions() {
    const loginStatus = await firstValueFrom(loginStatus$);
    if (loginStatus.status !== LoginStatus.LOGGED_IN) {
        throw new Error('need to be logged in to load suggestions');
    }
    const { data } = await getSuggestion(
        {},
        { headers: { authorization: `Bearer ${loginStatus.token}` } }
    );

    suggestions.set(data);
}
